import { type QueryHookOptions, useQuery } from "@apollo/client";
import { SupportRequestsListQuery } from "../graphql/queries";
import type {
  SupportRequestsListQueryType,
  SupportRequestsListQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useSupportRequestsQuery = (
  options?: QueryHookOptions<
    SupportRequestsListQueryType,
    SupportRequestsListQueryVariablesType
  >
) => {
  return useQuery<
    SupportRequestsListQueryType,
    SupportRequestsListQueryVariablesType
  >(SupportRequestsListQuery, options);
};
